import { render, staticRenderFns } from "./CustomPrint.vue?vue&type=template&id=2320955c&scoped=true&"
import script from "./CustomPrint.vue?vue&type=script&lang=js&"
export * from "./CustomPrint.vue?vue&type=script&lang=js&"
import style0 from "./CustomPrint.vue?vue&type=style&index=0&id=2320955c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2320955c",
  null
  
)

export default component.exports